import PetProfileFragment from './PetProfileFragment';
export default `
  mutation UpdatePetProfile($input: UpdatePetProfileInput!) {
    updatePetProfile(input: $input) {
      ...PetProfileFragment
    }
  }
  ${PetProfileFragment}
`;
